module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RtZmDl/tc-custom/9781452125046.jpg?1705347717362",
      "alt": "This image is the cover for the book Saying Grace"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Saying Grace\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("120 mealtime blessings from around the world, featuring a variety of sentiments, from the amusing to the heartfelt to the sacred.")]), _c('br'), _c('br'), _vm._v("Offering thanks for our daily bread is just about universal. A Chinese proverb gives us this reminder, “When eating bamboo shoots, remember the man who planted them.” The Irish lyrically ask that “the sweet light within you guide you on your way.” And for those who like to cut to the chase, there’s “Good bread, good meat, good God, let’s eat.” What they have in common is a joyous and heartwarming appreciation for life’s bounty. "), _c('br'), _c('br'), _vm._v("Beautifully illustrated, these pages a bounty of blessings, timeless prayers, and irreverent sayings that connect us to all cultures and countries. "), _c('i', [_vm._v("Saying Grace")]), _vm._v(" is an expression of gratitude perfect for holidays, passing around the family table, or for solitary contemplation—whenever the spirit moves you.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah McElwain, David Dean\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sarah McElwain is the editor of @METRO, The Metropolitan New York Library Council Newsletter and a teacher at The Writers Studio. She lives in New York City. David Dean is a London-based illustrator.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0